import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { NetworkSchemaType } from 'src/global/schemas/network.schema';

import { REDUX_SLICE } from '../constants';
import { AppSliceState } from '../types/app.type';

const initialState: AppSliceState = {
  network: '',
  networkInfo: null,
};

export const appSlice = createSlice({
  name: REDUX_SLICE.APP,
  initialState,
  reducers: {
    setNetwork: (state, action: PayloadAction<string>) => {
      state.network = action.payload;
    },
    setNetworkInfo: (state, action: PayloadAction<NetworkSchemaType | null>) => {
      state.networkInfo = action.payload;
    },
  },
});
